import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { useKey } from 'react-use';
import { $a, invokeEvent } from 'shared-base';
import ContentGoldenDetails from './ContentGoldenDetails';

export type ContentGoldenDetailsContainerProps = {
  id: string;
  onCta?: () => void;
};

export function ContentGoldenDetailsContainer(props: ContentGoldenDetailsContainerProps) {
  const dispatch = useDispatch();
  const palettes = useSelector(selectors.base.$palettes);
  const golden = useSelector(selectors.single.$currentGolden);

  const callbacks = useMemo(
    () => ({
      onOpenInPlayground: (id: string) => {
        invokeEvent('nav', { path: `/playground/generators/${id}` });
        props.onCta?.();
      },
      onPatch: (change: Json) => {
        dispatch($a('GOLDEN', 'patch', '', change));
      },
      onPrev: () => {
        dispatch($a('GOLDEN', 'prev'));
      },
      onNext: () => {
        dispatch($a('GOLDEN', 'next'));
      },
    }),
    []
  );

  useKey('ArrowLeft', callbacks.onPrev);
  useKey('ArrowRight', callbacks.onNext);

  if (!golden) return;

  return <ContentGoldenDetails golden={golden} callbacks={callbacks} />;
}

export default ContentGoldenDetailsContainer;
